import { useQuery } from '@apollo/client';
import { wearerBundleOptions, wearerBundleOptionsVariables } from 'src/queries/__generated__/wearerBundleOptions';
import wearerBundleProduct from 'src/queries/wearerBundleOptions.graphql';
import { extracted } from 'src/components/BundleProduct/BundleOptionsProvider';
import { WearerOptionMap, WearerOptions } from 'src/components/WeareBundleProduct/utils/wearer.types';
import { WearerSummary } from 'src/components/BundleProduct/BundleOptionsProvider';

export const useWearerBundles = (options: WearerOptionMap, summary: WearerSummary[], id?: number) => {
    const ids = [] as number[];
    const computedOptions = [] as WearerOptions[];

    if (id) {
        options.forEach((option) => {
            if (id === option.id) computedOptions.push(option);
        });
    } else {
        options.forEach((option) => {
            ids.push(option.id);
            computedOptions.push(option);
        });
    }

    const variableIds = id ? [id] : ids;

    const { data } = useQuery<wearerBundleOptions, wearerBundleOptionsVariables>(wearerBundleProduct, {
        variables: { ids: variableIds, noAuthorization: true },
        ssr: false,
        fetchPolicy: 'cache-first',
    });

    if (!data)
        return {
            array: computedOptions.map((option, index) => ({
                id: option.id,
                maxQty: option.max_qty,
                bundleInformation: summary.find((bundle) => bundle.sku === option.sku) || summary[index],
            })),
            loading: true,
        };

    return {
        array: computedOptions.map((option, index) => {
            const value = data.wearerBundleOptions.find((wbo) => wbo?.sku === option.sku);

            const bundleInformation = summary.find((bundle) => bundle.sku === value?.sku) || summary[index];
            return {
                ...extracted({ max_qty: option.max_qty, target_configurable: value }, option.bundle_options),
                id: option.id,
                bundleInformation,
                details: {
                    description: option.description,
                    mediaEntries: option.media_gallery,
                    is24HourDelivery: option.is_24_hour_delivery,
                    canCustomise: option.can_customise,
                    name: option.name,
                    sizeGuides: option.size_guides,
                },
                bundleVariants: value?.variants,
            };
        }),
        loading: false,
    };
};
